module.exports = __webpack_public_path__ + "static/img/app-info-demo@2x.8037048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-info-demo@2x.png
// module id = PgkQ
// module chunks = 1